<template>
  <div class="detail-contain">
    <div class="step-box" v-if="supervisionInfoList.length === 0 && supervisionId!==''">
      <button
        class="step-btn"
        @click="$router.push({path:'/guide/upload', query:{rectifyStatus: supervisionInfo.rectifyStatus,supervisionId}})"
      >
        上传{{supervisionInfo.rectifyStatus === 'guideSuperviseNotice' ? '整改方案' :
        (supervisionInfo.rectifyStatus === 'guideSupervisePlan'? '整改资料' : '整改通知书')}}
      </button>
    </div>
    <div class="info-contain" v-if="supervisionInfoList.length > 0 && supervisionInfoList[0] !== ''">
      <div class="info-title">监管整改明细</div>

        <div class="info-body line_bottom" v-for="(item,index) in supervisionInfoList" :key="'info-'+ index">
          <div class="circel"></div>
          <div class="info-body-box">
            <div class="name">
              {{item.rectifyStatus === 'guideSuperviseNotice' ? '整改通知书' :
              (item.rectifyStatus === 'guideSupervisePlan'? '整改方案' : '整改资料')}}
            </div>
            <div class="name-box">{{item.creatorName}}<span style="margin-left: 5px"> {{item.createTime}}</span> 上传</div>
            <div class="box-content">{{item.description}}</div>
            <div class="info-img-box">
              <van-image
                class="info-img"
                v-for="(picItem,index) in item.attach"
                :key="picItem"
                :src="picItem"
                fit="cover"
                @click="onDialogOpen(item,index)"
              />
            </div>
          </div>
        </div>
      <button
        v-if="supervisionInfoList.length > 0 && supervisionInfoList.length < 3 && supervisionInfo.rectifyStatus !== 'guideSuperviseMaterial'"
        class="add-btn"
        @click="$router.push({path:'/guide/upload', query:{rectifyStatus: supervisionInfo.rectifyStatus,supervisionId}})"
      >
        +
        {{supervisionInfo.rectifyStatus === 'guideSuperviseNotice' ? '整改方案' :
        (supervisionInfo.rectifyStatus === 'guideSupervisePlan'? '整改资料' : '整改通知书')}}
      </button>
    </div>
    <div class="info-contain contain-bottom" v-if="supervisionId !== '' && showDiv === true">
      <div class="top-box line_bottom">
        <div class="top-title">重点关注中</div>
        <div class="time-box">
          <div class="time-content">{{supervisionLogList[0] ? supervisionLogList[0].createTime : ''}} 开始</div>
          <div class="time-content">剩余{{supervisionInfo.daysStr}}</div>
        </div>
      </div>
      <div class="body-box">
        <div class="body-top">
          <div class="top-content">已累计扣分 {{totalScore}} 分</div>
          <div class="top-tips">(行政处罚或其他违规行为扣分超过10分即被纳入重点关注)</div>
        </div>
        <div class="cut-box" v-for="item in cutPointList" :key="item.id">
          <div class="cut-top">
            <div class="cut-title">{{item.punishDetailType}}</div>
            <div class="cut-point">{{item.score.toFixed(1)}}</div>
          </div>
          <div class="cut-time">{{filtTime(item.punishTime).substring(0,10)}}</div>
        </div>
      </div>
    </div>
    <div class="show-history" v-if="!showHistory && !showEmpty && showDiv === true" @click="showHistory=true">
      <span>查看历史监管记录</span>
      <img src="../../assets/guideSystem/show_more.png" />
    </div>
    <!-- 历史监管记录 -->
    <empty :type="3" v-if="historyList.length === 0 && !isLoading && showEmpty"></empty>
    <div v-if="showHistory" :class="(showHistory && showEmpty) ? 'show-empty' : ''">
      <div v-for="(item,index) in historyList" :key="'histore-' + index">
        <div class="history-title">
          <div class="t-title">历史监管记录</div>
          <div class="t-time">{{item.createTime}}</div>
        </div>
        <div class="info-contain" v-if="item.attachList.length > 0">
          <div class="info-title">监管整改明细</div>
          <div
            class="info-body line_bottom"
            v-for="(attachItem,key) in item.attachList"
            :key="'attachItem-'+ key"
          >
            <div class="circel"></div>
            <div class="info-body-box">
              <div class="name">
                {{attachItem.rectifyStatus === 'guideSuperviseNotice' ? '整改通知书' :
                (attachItem.rectifyStatus === 'guideSupervisePlan'? '整改方案' : '整改资料')}}
              </div>
              <div class="name-box">{{attachItem.creatorName}} {{attachItem.createTime}} 上传</div>
              <div class="box-content">{{attachItem.description}}</div>
              <div class="info-img-box">
                <van-image
                  class="info-img"
                  v-for="(picItem,index) in attachItem.attach"
                  :key="picItem"
                  :src="picItem"
                  fit="cover"
                  @click="onDialogOpen(attachItem, index)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="info-contain contain-bottom">
          <div class="top-box line_bottom">
            <div class="top-title" v-if="item.superviseState === 'new'">{{item.superviseStateName|| '上线重点关注名单'}}</div>
            <div class="top-title" v-if="item.superviseState === 'cancel'">退出重点关注名单</div>
            <div class="time-box">
              <div class="time-content" v-if="item.superviseState === 'new'">{{item.createTime}} 开始</div>
              <div class="time-content" v-if="item.superviseState === 'cancel'">{{item.createTime}}</div>
              <!-- <div class="time-content">剩余{{supervisionInfo.daysStr}}</div> -->
            </div>
          </div>
          <div class="body-box">
            <div class="body-top">
              <div class="top-content" v-if="item.superviseState === 'new'">已累计扣分 {{item.totalScore}} 分</div>
              <div class="top-content" v-if="item.superviseState === 'cancel' && item.cancelType === 'plead'">导游申辩成功</div>
              <div class="top-content" v-if="item.superviseState === 'cancel' && item.cancelType === 'reform'">导游整改完成</div>
              <div class="top-content" v-if="item.superviseState === 'cancel' && item.cancelType === 'auto'">重点关注到期，系统自动退出</div>
              <div class="top-tips" v-if="item.superviseState === 'new'">(行政处罚或其他违规行为扣分超过10分即被纳入重点关注)</div>
            </div>
            <div
              class="cut-box"
              v-for="punishItem in item.punishList"
              :key="'punishItem-' +punishItem.id"
            >
              <div class="cut-top">
                <div class="cut-title">{{punishItem.punishDetailType}}</div>
                <div class="cut-point">{{punishItem.score.toFixed(1)}}</div>
              </div>
              <!-- <div class="cut-time">{{filtTime(punishItem.punishTime)}}</div> -->
              <div class="cut-time">{{punishItem.punishTime}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="show-history" @click="showHistory=false" v-if="!showEmpty">
        <span>收起历史监管记录</span>
        <img src="../../assets/guideSystem/shouqi_up.png" />
      </div>
    </div>
  </div>
</template>
<script>
    import { ImagePreview } from 'vant';
    import empty from 'comps/empty';
    import api from '../../service/modules/guide';
    import apimessage from '../../service/modules/message'
    export default {
        components: {
            empty
        },

        data () {
            return {
                showHistory: false,
                supervisionId: '',
                guideId: '',
                supervisionInfo: {
                    rectifyStatus: 'guideSuperviseMaterial'
                },
                supervisionLogList: [{ disposeDesc: '' }],
                cutPointList: [],
                interval: '', // 倒计时
                leftSec: 2222222,
                // 当前监管明细
                supervisionInfoList: [''],
                // 历史监管记录
                historyList: [],
                isLoading: true,
                showEmpty: false,
                showDiv: false
            };
        },

        computed: {
            totalScore () {
                let score = 0;
                this.cutPointList.forEach(item => {
                    score += item.score;
                });
                return -score;
            },
            showTime () {
                let day = parseInt(this.leftSec / 86400);
                let hour = parseInt((this.leftSec % 86400) / 3600);
                let min = parseInt((this.leftSec % 3600) / 60);
                let sec = this.leftSec % 60;
                return {
                    day: day < 10 ? '0' + day : day,
                    hour: hour < 10 ? '0' + hour : hour,
                    min: min < 10 ? '0' + min : min,
                    sec: sec < 10 ? '0' + sec : sec
                };
            }
        },
        watch: {},

        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            onDialogOpen (item, startPosition = 0) {
                // let name = item.rectifyStatus === 'guideSuperviseNotice' ? '整改通知书'
                //     : (item.rectifyStatus === 'guideSupervisePlan' ? '整改方案' : '整改资料')
                let photos = item.attach
                // let credentialsPhoto = [{ name: name, photos: photos }]
                // let photos = this.credentialsPhoto[index].photos
                ImagePreview({
                    images: photos,
                    startPosition: startPosition,
                    closeOnPopstate: true,
                    onClose () {
                        // do something
                    }
                });
                // this.$router.push({ path: '/guide/photo', query: { credentialsPhoto: JSON.stringify(credentialsPhoto) } })
            },
            filtTime (str) {
                console.log('str:', str)
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                console.log('rrrrrrrrrrrrrrrrrrrrrrr', new Date(parseInt(str)).toLocaleString().replace(/[\u4e00-\u9fa5]/g, ' ').replace(/\//g, '-'))
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
                // var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m;
                return strDate;
            },
            myPending (index) {
                this.currentIndex = index;
            },
            getData () {
                api
                    .querySupervisionInfo({
                        guideId: this.guideId
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.cutPointList = res.data;
                        }
                    });
            },
            getInfo () {
                api
                    .querySupervisionByGuideId({
                        guideId: this.guideId
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.supervisionInfo = res.data.supervisionInfo || {};
                            this.supervisionLogList = res.data.supervisionLogList || [];
                            // 为了解决模块闪现的问题，先隐藏拉完数据再展示
                            this.showDiv = true
                            if (this.supervisionLogList.length > 0) {
                                this.supervisionLogList[0].disposeDesc =
                                    this.supervisionLogList[0].disposeDesc + '即被纳入重点关注';
                            } else {
                                this.supervisionLogList.push({ disposeDesc: '' });
                            }
                        }
                    });
            },
            // 倒计时
            countDown () {
                this.interval = setInterval(() => {
                    if (this.leftSec > 0) {
                        this.leftSec--;
                    } else {
                        clearInterval(this.interval);
                    }
                }, 1000);
            },
            getSupervisionrectify () {
                api
                    .querySupervisionRectify({
                        supervisionId: this.supervisionId
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            let arr = []
                            res.data.forEach(item => {
                                item.attach = item.attach.split(',');
                                switch (item.rectifyStatus) {
                                case 'guideSuperviseMaterial':
                                    arr[2] = item
                                    break;
                                case 'guideSuperviseNotice':
                                    arr[0] = item
                                    break;
                                case 'guideSupervisePlan':
                                    arr[1] = item
                                    break;
                                }
                            });
                            this.supervisionInfoList = arr;
                        }
                    });
            },
            getHistory () {
                api.queryHistorySupervision({ guideId: this.guideId }).then(res => {
                    if (res.ret === 0) {
                        this.isLoading = false
                        this.historyList = res.data;
                        this.historyList.map(item => {
                            let arr = []
                            item.attachList.forEach(attachItem => {
                                attachItem.attach = attachItem.attach.split(',');
                                switch (attachItem.rectifyStatus) {
                                case 'guideSuperviseMaterial':
                                    arr[2] = attachItem
                                    break;
                                case 'guideSuperviseNotice':
                                    arr[0] = attachItem
                                    break;
                                case 'guideSupervisePlan':
                                    arr[1] = attachItem
                                    break;
                                }
                            });
                            item.attachList = arr
                            let total = 0;
                            item.punishList.forEach(pItem => {
                                total += pItem.score;
                            });
                            item.totalScore = -total;
                            return item;
                        });
                    }
                });
            }
        },

        mounted () {},
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            this.supervisionId =
                this.$route.query.supervisionId || '';
            this.guideId = this.$route.query.guideId;
            if (this.supervisionId !== '') {
                this.getData();
                this.getInfo();
                this.getSupervisionrectify();
            } else {
                this.showHistory = true
                this.showEmpty = true
            }
            this.getHistory();
        },
        destroyed () {
            clearInterval(this.interval);
        }
    };
</script>
<style scoped lang="less">
.detail-contain {
  flex: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(251, 251, 251, 1);
  padding: 0 12px;
  .step-box {
    margin-top: 16px;
    .step-btn {
      width: 100px;
      height: 28px;
      background: rgba(54, 179, 116, 1);
      border-radius: 1px;
      font-size: 12px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
    }
  }
  .contain-bottom {
    margin-bottom: 24px;
  }
  .show-history {
    min-height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #9b9b9b;
    margin-bottom: 20px;
    img {
      height: 4px;
      width: 7px;
      margin-left: 3px;
    }
  }
  .show-empty{
    margin-top: 20px;
  }
  .history-title {
    height: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .t-title {
      font-size: 16px;
      font-family: PingFang SC, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: 500;
     color: rgba(51, 51, 51, 1);
    }
    .t-time {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
  .info-contain {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .top-box {
      padding: 16px;
      display: flex;
      flex-direction: column;
      // border-bottom: 1px solid #eeeeee;
      .top-title {
        font-size: 14px;
        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 500;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
        margin-bottom: 7px;
      }
      .time-box {
        display: flex;
        justify-content: space-between;
        .time-content {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
        }
      }
    }
    .body-box {
      padding: 16px;
      display: flex;
      flex-direction: column;
      .body-top {
        display: flex;
        flex-direction: column;
        .top-content {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 77, 77, 1);
          line-height: 14px;
          margin-bottom: 4px;
        }
        .top-tips {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
          margin-bottom: 4px;
        }
      }
      .cut-box {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        .cut-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .cut-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
          }
          .cut-point {
            font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        -webkit-font-smoothing: antialiased;
            font-weight: bold;
            color: rgba(255, 77, 77, 1);
            line-height: 12px;
          }
        }
        .cut-time {
          margin-top: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
    }
    .info-title {
      margin: 16px 0 0 16px;
      font-size: 14px;
            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
      font-weight: 500;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
    }
    .info-body {
      // display: flex;
      padding-top: 16px;
      // border-bottom: 1px solid #eeeeee;
      position: relative;
      padding-left: 34px;
      .circel {
        position: absolute;
        top: 18px;
        left: 16px;
        width: 10px!important;
        height: 10px!important;
        background: rgba(54, 179, 116, 1);
        border-radius: 50%;
        // margin: 2px 8px 0 6px;
      }
      .info-body-box {
        display: flex;
        flex-direction: column;
        .name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          line-height: 14px;
          margin-bottom: 4px;
        }
        .name-box {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
          margin-bottom: 12px;
        }
        .box-content {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-bottom: 12px;
        }
        .info-img-box {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 6px;
          .info-img {
            margin-bottom: 10px;
            margin-right: 10px;
            width: 94px;
            height: 94px;
            border-radius: 3px;
          }
        }
      }
    }
    .info-body:last-child {
      border-bottom: none!important;
    }
    .info-body:last-child::after {
      background: none;
    }
    .bt0{
      border-bottom: 0;
    }
    .add-btn {
      width: 76px;
      height: 28px;
      background: rgba(54, 179, 116, 1);
      border-radius: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      margin-bottom: 16px;
      font-size: 12px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 12px;
      margin-left: 35px;
    }
  }
}
</style>
